import { useRouter } from 'next/router'

import ArticleAuthor from '~/shared/components/Articles/ArticleAuthor/ArticleAuthor'
import { Link } from '~/components'
import { SanityImage } from '~/types/sanity'

import styles from '~/shared/components/Articles/Articles.module.css'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '330px' }]

export default function HorisontalArticleItem({
  author,
  authorAvatar,
  className = '',
  ingress,
  landscapeImage,
  slug,
  title,
  releaseDate,
}: {
  author?: string
  authorAvatar?: SanityImage
  className?: string
  content: unknown[]
  ingress?: string
  landscapeImage: SanityImage
  slug: string
  title: string
  releaseDate: string
}): React.ReactElement {
  const { pathname } = useRouter()

  return (
    <Link className={`w-full ${className}`} to={`${pathname}/${slug}`}>
      <article>
        <ArticleAuthor author={author} authorAvatar={authorAvatar} className="mb-2" releaseDate={releaseDate} />
        <div className="mt-4">
          <ResponsiveImage
            alt={landscapeImage.alt}
            className="mb-2 shrink-0 rounded"
            height={200}
            imageClassName="mb-2 flex-shrink-0 rounded"
            imageWidths="330"
            mediaQuery={mediaQuery}
            srcKey={landscapeImage.srcKey ?? ''}
            width={330}
          />
          <header>
            <h2 className="mb-1 text-lg font-semibold">{title}</h2>
          </header>
          <div className={`${styles.ingress} ${styles['clamp-5']} leading-7`}>{ingress}</div>
        </div>
      </article>
    </Link>
  )
}
